import { useRouter } from "next/router";

function useCheckDashboardContainer() {
  const { pathname } = useRouter();

  if (pathname === "/dashboard") {
    return true;
  }
  return false;
}

export default useCheckDashboardContainer;
